import { render, staticRenderFns } from "./DealStatus.vue?vue&type=template&id=219a11a8&scoped=true&"
import script from "./DealStatus.vue?vue&type=script&lang=js&"
export * from "./DealStatus.vue?vue&type=script&lang=js&"
import style0 from "./DealStatus.vue?vue&type=style&index=0&id=219a11a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219a11a8",
  null
  
)

export default component.exports